import React from 'react'

const recoveryAgencyHOC = (Component) => {
    const agencyList = [
        {
            sr_no: 1,
            agency_name: 'Bhavani Business Solutions',
            agency_address: 'Ground floor Canara Business park, Andheri Link Road Laxmi Nagar Ghatkopar East',
            contact_no: 9759051221
        },
        {
            sr_no: 2,
            agency_name: 'CS Enterprises',
            agency_address: '#173, 1St Cross, KK LayoutNagarabhavi 2nd Stage,Bangalore - 560072 Behind Mahesh PU College',
            contact_no: 9353683628,
        },
        {
            sr_no: 3,
            agency_name: 'Friends Business Solution',
            agency_address: '15/3, Annapurnaeshwari Towers,1st Floor, Kumarans College Road,Brundhavan Layout, Bangalore 560061',
            contact_no: 9008671003,
        },
        {
            sr_no: 4,
            agency_name: 'Garika Financial services',
            agency_address: 'H No. 3-6-522/2/a, 3rd Floor Hymat Nagar main Road,Hyderabad - 500029.',
            contact_no: 8520801642,
        },
        {
            sr_no: 5,
            agency_name: 'Master Services',
            agency_address: 'Old No 89 New No 19,1st C Main Road, 40th Cross,Jayanagar 8th Block,Bangalore 560070 opp to Shivaji military hotel',
            contact_no: 9740141919,
        },
        {
            sr_no: 6,
            agency_name: 'RR Associates',
            agency_address: 'Flat No 4, Siddhartha Appartments 1st Floor No 203, Habibulla Road,T Nagar Chennai - 600017.',
            contact_no: 9884808601,
        },
        {
            sr_no: 7,
            agency_name: 'Saviour Management Services',
            agency_address: '1-F 2ND FLOOR BABU JAGAN STREET KANNAN BALA NAGAR ARUMBKKAM CHENNAI-600106,',
            contact_no: 9176358695,
        },
        {
            sr_no: 8,
            agency_name: 'SS Agency',
            agency_address: '6-4-423/A , krishna nagar colony, Bholakpur Bhoiguda, Hyderabad, Telangana 500080',
            contact_no: 9160456077,
        },
        {
            sr_no: 9,
            agency_name: 'SS Associates',
            agency_address: '103 Sai Aishwarya classic enclave near samatha nagar bus stop RR Nagar old bowenpally secunderabad 500011',
            contact_no: 9010675809
        },
        {
            sr_no: 10,
            agency_name: 'Aerial Telecom Solutions Pvt Ltd',
            agency_address: 'Building No- 17 , Block A , Sec- 63 Noida Uttar Pradesh 201301',
            contact_no: 9650202424
        },
        {
            sr_no: 11,
            agency_name: 'Dealz Management Technologies Private Limited',
            agency_address: 'Office No.- 1208, 12th floor Padma Tower -1 Rajendra place -110008',
            contact_no: 9999141941
        },
        {
            sr_no: 12,
            agency_name: 'IG TECHSERV PRIVATE LIMITED',
            agency_address: 'Building No- 73 , Block H , Sec- 63 Noida Uttar Pradesh 201301',
            contact_no: 9811336551
        },
        {
            sr_no: 13,
            agency_name: 'Collexiom',
            agency_address: 'Office No.306 plot C-1/4 , 3rd Floor Nikta Tower -2 Commercial Complex Azad Pur -110033',
            contact_no: 8383883300
        },
        {
            sr_no: 14,
            agency_name: 'Rivyanshi Management',
            agency_address: 'FD-38 Near Cominute Center Tagore Garden - 110027',
            contact_no: 9716114191
        },
        {
            sr_no: 15,
            agency_name: 'Sarv Managements',
            agency_address: 'S4-71 New Mahavir Nagar Near Janak Puri East Metro Station - 110018',
            contact_no: 9654543559
        },
        {
            sr_no: 16,
            agency_name: 'I-Naxe Management Pvt Ltd',
            agency_address: 'WZ-122 3rd floor left side Budhella Vikaspuri- 110018',
            contact_no: 9168801222
        },
        {
            sr_no: 17,
            agency_name: 'Vega Corporate Services Pvt Ltd',
            agency_address: 'D-25 2nd Floor Lajpat Nagar Part-02 Delhi 110024',
            contact_no: 8898999909
        },
        {
            sr_no: 18,
            agency_name: 'Vihaan Info Services',
            agency_address: '1006, 10th Floor,Flix tower, LDS Road,Bhandup west, Mumbai',
            contact_no: 9871996638
        },
        {
            sr_no: 19,
            agency_name: 'Solutions Offshoot',
            agency_address: 'F-Block, Sec-8,Noida, UP',
            contact_no: 9654543559
        },
        {
            sr_no: 20,
            agency_name: 'Shiva Associates',
            agency_address: 'B2A/10 Janakpuri East New Delhi 110058',
            contact_no: 9999764554
        },
        {
            sr_no: 21,
            agency_name: 'Shree Bihari Lal Services',
            agency_address: 'RZ D-18 1st to 3rd floor Dashrath puri mahavir enclave new delhi 110045',
            contact_no: 9717008775
        },
        {
            sr_no: 22,
            agency_name: 'SS Telecom',
            agency_address: '4-floor,house no 207,main road roshan appartment,zakir nagar Okhala',
            contact_no: 9555880309
        },
        {
            sr_no: 23,
            agency_name: 'NSB BPO Solutions Pvt Ltd',
            agency_address: 'Plot no-97,Zone 2 MP Nagar Shiksha Mandal , Bhopal MP 462011',
            contact_no: 9717777797
        },
        {
            sr_no: 24,
            agency_name: 'Prolynk Network Pvt Ltd',
            agency_address: 'Sahara Bank Building ,WZ 100/1 , Ground Floor , Titar Pur , Tagore Garden',
            contact_no: 9811870167
        },
        {
            sr_no: 25,
            agency_name: 'Core Debt Management Services',
            agency_address: 'A-5 3rd Floor , Shankar Garden , Vikaspuri',
            contact_no: 9811870167
        },
        {
            sr_no: 26,
            agency_name: 'Goalcryst India Pvt Ltd.',
            agency_address: 'No.1478, 39th Cross Road, Jayanagar 4th T Block Bangalore 560041,',
            contact_no: 8618482215
        },
        {
            sr_no: 27,
            agency_name: 'CLXNS TECHNOLOGIES PRIVATE LIMITED',
            agency_address: '1202, Oriana Business Park, Road No.22, Wagle Industrial Estate, Thane West, Mumbai 400604',
            contact_no: 9873090516
        },
        {
            sr_no: 28,
            agency_name: 'OM SAI ENTERPRISES',
            agency_address: 'B32 GROUND FLOOR SAIDULAJAB NEAR SAKET METRO STATION NEW DELHI 110030',
            contact_no: 9873090516
        },
        {
            sr_no: 29,
            agency_name: 'Konexions back office services Pvt Ltd',
            agency_address: 'l-16, Lajpat Nagar Part-ll,New Delhi-110062,',
            contact_no: 9654091003
        },
        {
            sr_no: 30,
            agency_name: 'Deetya Associates',
            agency_address: 'B-43 Basement T C Jaina Tower 1 Janakpuri District Centre New Delhi 110058',
            contact_no: 8700566428
        },
        {
            sr_no: 31,
            agency_name: 'PREFIX SERVICES',
            agency_address: 'J-21 A-2 FF Bander Wali khui Ramesh Nagar metro station near gate no 3 110015',
            contact_no: 9355236993
        },
        {
            sr_no: 32,
            agency_name: 'THE SPARKLE HUES',
            agency_address: 'C-41 Above PNB Bank Sec-58 Noida',
            contact_no: 7827232659
        },
        {
            sr_no: 33,
            agency_name: 'YOUTH CHALLENGE SERVICES PRIVATE LIMITED',
            agency_address: '236 sant nagar east of kailash delhi 110065',
            contact_no: 9910238497
        },
        {
            sr_no: 34,
            agency_name: 'Exeliq Cabs Private Limited',
            agency_address: 'LGF, Khasra no. 369, Mehrauli-Gurgaon Rd, Sultanpur, Delhi 110030',
            contact_no: 8859246544
        },
    ];
    return () => <Component agencyList={agencyList} />;
};

export default recoveryAgencyHOC